<template>
    <div>
        <v-dialog :value="!!activeRideId" lazy @input="activeRideId = null">
            <ride-page v-if="activeRideId" :ride_id="activeRideId"/>
        </v-dialog>
        <v-card>
            <v-card-title>
                <b>Past 60 Min Rides</b>
                <v-spacer></v-spacer>
                <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                        @keyup.enter="getData"
                ></v-text-field>
            </v-card-title>
            <v-data-table :url="url"
                          :headers="headers"
                          :items="data"
                          :pagination.sync="pagination"
                          :total-items="totalItems"
                          :loading="loading"
            >
                <template v-slot:items="props">
                    <td class="text-xs-left">{{ props.item.ride_id }}</td>
                    <td class="text-xs-left">{{ props.item.captain_name }}</td>
                    <td class="text-xs-left">{{ props.item.km_count }}</td>
                    <td class="text-xs-left">{{ props.item.elapsed_time }}</td>
                    <td class="text-xs-left">{{ props.item.waiting_time }}</td>
                    <td class="text-xs-left">{{ props.item.meter_price }}</td>
                    <td class="text-xs-left">{{ props.item.ratio }}</td>
                    <td class="text-xs-left">{{ props.item.service_name }}</td>
                    <td class="text-xs-left">{{ props.item.created_at }}</td>
                    <td class="text-xs-left">
                        <v-btn color="primary" @click="() => openRideModal(props.item.ride_id)">Details</v-btn>
                    </td>

                </template>
                <v-alert v-slot:no-results :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";
    import CarInfo from "@/components/confirmation_captain_components/CarInfo";
    import RidePage from "@/views/RidePage";

    export default {
        name: "Ongoing",
        components: {CarInfo, DataTable, RidePage},
        data() {
            return {
                url: 'ride/past?last_minutes=120',
                headers: [
                    {text: 'ID', value: 'ride_id'},
                    {text: 'Captain', value: 'captain_name'},
                    {text: 'Distance', value: 'km_count'},
                    {text: 'Time', value: 'elapsed_time'},
                    {text: 'Waiting', value: 'waiting_time'},
                    {text: 'Price', value: 'meter_price'},
                    {text: 'Ratio', value: 'ratio'},
                    {text: 'Service', value: 'service_name'},
                    {text: 'Last Update', value: 'updated_at'},
                    {text: 'Details', value: 'details'}

                ],
                data: [],
                loading: false,
                search: '',
                totalItems: 0,
                pagination: {},
                activeRideId: null

            };
        },
        watch: {
            pagination: {
                handler() {
                    this.getData();
                },
                deep: true
            },
        },
        mounted() {
            this.getData();
        },
        methods: {
            updateRatio(updates_count, elapsed_time_in_seconds) {
                if (Math.floor(elapsed_time_in_seconds) > 0) {
                    return this.round(100 * updates_count / (elapsed_time_in_seconds / 10), 0) + '%';
                }
                return 'INFINITY';
            },
            round(val, point_cnt = 2) {
                return Math.round((val) * Math.pow(10, point_cnt)) / Math.pow(10, point_cnt)
            },
            openRideModal(ride_id) {
                this.activeRideId = ride_id
            },
            getData() {
                this.loading = true;
                const params = new URLSearchParams();
                params.append('page', this.pagination.page);
                params.append("perPage", String(this.pagination.rowsPerPage));
                params.append("search", String(this.search));
                this.axios.get(this.url, {params})
                    .then(res => {
                        res.data.data.data.forEach(e => e.ratio = this.updateRatio(e.route_count, e.elapsed_time * 60));
                        this.data = res.data.data.data;
                        this.totalItems = res.data.data.total;
                        this.pagination.rowsPerPage = Number(res.data.data.per_page);
                        this.loading = false;
                    }).catch(err => {
                    console.log(err.message);
                    this.loading = false;
                });
            },
            add(elem) {
                this.data.push(elem);
            }
        }
    }
</script>

<style scoped>

</style>